// Business. This is the business layer, which ties all the "lower" layers of
// the latestStore together. Many invocations from outside the store come in
// through the business layer.

import { systemStore } from '../../stores';
import api from './api';
import utils from './utils';
import storage from './storage';

let images = null;

let isLoading = false;

const business = {
  // load data: load the initial set of data
  loadData: async () => {
    // let images = storage.getImages();
    if (!images) {
      if (!isLoading) {
        isLoading = true;
        images = await api.apiLoadData();
        const thumbnailSize = storage.getThumbnailSize();
        const maxNrImages = storage.getMaxNrImages();
        const clientWidth = systemStore.getClientWidth();
        const pixelRatio = systemStore.getPixelRatio();
        const spacing = systemStore.getSpacing();

        const rows = utils.calculateRows(images, {
          clientWidth,
          thumbnailSize,
          pixelRatio,
          maxNrImages,
          spacing,
        });

        storage.setRows(rows);
        isLoading = false;
      }
    }
  },

  // Load more data, starting at the cursor
  loadMoreData: async (cursor) => {
    // let images = storage.getImages();
    console.log('load more data ' + cursor);
    if (!isLoading) {
      isLoading = true;
      const moreImages = await api.apiLoadData(cursor);

      console.log('trimming images ' + cursor);
      let i = images.length - 1;
      console.log('last image: ' + images[i].cursor);
      while (i && images[i].cursor < cursor) {
        console.log('popping image ' + images[i].cursor);
        images.pop();
        i--;
      }
      images.push(...moreImages);
      console.log(
        'after push: last image is ' +
          JSON.stringify(images[images.length - 1]),
      );
      const thumbnailSize = storage.getThumbnailSize();
      const maxNrImages = storage.getMaxNrImages();
      const clientWidth = systemStore.getClientWidth();
      const pixelRatio = systemStore.getPixelRatio();
      const spacing = systemStore.getSpacing();

      const rows = utils.calculateRows(images, {
        clientWidth,
        thumbnailSize,
        pixelRatio,
        maxNrImages,
        spacing,
      });

      storage.setRows(rows);
      isLoading = false;
    }
  },

  // When leaving the page, do cleanup
  unloadData: () => {
    // to be implemented
  },

  updateThumbnailSize: (thumbnailSize) => {
    storage.setThumbnailSize(thumbnailSize);
    const clientWidth = systemStore.getClientWidth();
    const maxNrImages = storage.getMaxNrImages();
    const pixelRatio = systemStore.getPixelRatio();
    const spacing = systemStore.getSpacing();

    const rows = utils.calculateRows(images, {
      clientWidth,
      thumbnailSize,
      pixelRatio,
      maxNrImages,
      spacing,
    });

    storage.setRows(rows);
  },

  // On desktop, changing the window size must be handled
  setWindowWidth(windowWidth) {
    const currentWindowWidth = systemStore.getWindowWidth();
    if (windowWidth !== currentWindowWidth) {
      systemStore.setWindowWidth(windowWidth);
      const clientWidth = systemStore.getClientWidth();
      const maxNrImages = storage.getMaxNrImages();
      const thumbnailSize = storage.getThumbnailSize();
      const pixelRatio = systemStore.getPixelRatio();
      const spacing = systemStore.getSpacing();

      if (images) {
        const rows = utils.calculateRows(images, {
          clientWidth,
          thumbnailSize,
          pixelRatio,
          maxNrImages,
          spacing,
        });

        storage.setRows(rows);
      }
    }
  },
};

export default business;
